module.exports = __webpack_public_path__ + "static/media/VideoPlayerIcon.ec98c5b3.svg";